import { TooltipContent } from '@anm/components/Tooltip';
import InputLabel from '@anm/components/form/InputLabel';
import { flexCenter, flexColumn, flexRow, media, InfoLabel } from '@anm/styles/helpers';
import styled from 'styled-components';

export const FieldGroup = styled.div``;

export const RelativeBlock = styled.div`
  position: relative;

  ${TooltipContent} {
    transform: translateY(-86px);
    &:before {
      right: 16px;
      border-width: 0 9px 10px 9px;
    }
  }

  ${InfoLabel} {
    z-index: 1;
    top: 16px;
    right: 15px;
    position: absolute;
  }
`;

export const TooltipText = styled.p`
  margin: 0;
  color: #fff;
  font-size: 16px;
  max-width: 210px;
  line-height: 20px;
  a {
    color: var(--blue_100);
  }
`;

const fieldsOnMobile = media.phone`
  ${flexColumn};
  & ${FieldGroup}:first-child {
    margin: 0;
  }
`;

export const Fields = styled.div`
  ${flexRow};
  width: 100%;
  & ${FieldGroup} {
    flex: 1;
    &:first-child {
      margin-right: 20px;
    }
  }
  ${fieldsOnMobile};
`;

const FormWrapper = styled.form`
  ${flexCenter};
  ${flexColumn};
  margin-top: 32px;
  & input {
    padding-top: 4px;
    padding-left: 17px;
    margin-bottom: 26px;
    &::placeholder {
      color: #919eab;
    }
  }
  & ${InputLabel} {
    display: none;
  }
  button {
    margin-top: 4px;
  }
`;

export default FormWrapper;
